(ns app.team.add-user
  "The UI that lets you invite a new user to the team / organization."
  (:require [parts.replicant.command :as command]
            [ui.app-frame :as app-frame]))

(defn render
  [state]
  (let [cmd {:command/kind :command/team-add-user
             :command/data {:email (::email state)}}
        cmd-action [:data/command
                    cmd
                    {:on-success [[:data/query {:query/kind :query/team}]
                                  [:store/assoc-in
                                   [:location]
                                   {:location/page-id :pages/team}]]}]
        has-email? (seq (::email state))]
    (app-frame/app-frame
      state
      [:div
       {}
       [:div
        {:class ["mb-6" "flex" "items-center" "gap-3" "max-w-xl" "mx-auto"]}
        [:ui/a.link
         {:ui/location
          {:location/page-id :pages/team
           :location/params {}}
          :class ["text-gray-400" "hover:text-gray-600"]}
         [:svg {:xmlns "http://www.w3.org/2000/svg" :viewBox "0 0 20 20"
                :fill "currentColor" :class ["w-5" "h-5"]}
          [:path {:fill-rule "evenodd"
                  :d "M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z"
                  :clip-rule "evenodd"}]]]
        [:h1
         {:class ["text-2xl" "font-bold" "text-gray-900"]}
         "Invite Team Member"]]

       [:div
        {:class ["bg-white" "rounded-xl" "shadow-sm" "border" "border-gray-200"
                 "overflow-hidden" "max-w-xl" "mx-auto"]}

        [:div
         {:class ["px-6" "py-5" "border-b" "border-gray-100"]}
         [:div
          {:class ["rounded-lg" "bg-amber-50" "border" "border-amber-200" "p-4"]}
          [:div
           {:class ["flex" "gap-3"]}
           [:div
            {:class ["shrink-0" "mt-0.5"]}
            [:svg {:xmlns "http://www.w3.org/2000/svg" :viewBox "0 0 20 20"
                   :fill "currentColor" :class ["w-5" "h-5" "text-amber-500"]}
             [:path {:fill-rule "evenodd"
                     :d "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                     :clip-rule "evenodd"}]]]
           [:div
            [:div
             {:class ["text-sm" "font-semibold" "text-amber-900"]}
             "Important"]
            [:div
             {:class ["text-sm" "text-amber-800" "mt-1"]}
             "Every team member has the "
             [:span {:class ["font-semibold"]} "same rights"]
             " as you:"]
            [:ul
             {:class ["text-sm" "text-amber-800" "mt-2" "ml-4" "list-disc"
                      "space-y-1"]}
             [:li [:span {:class ["font-medium"]} "Remove"] " you or others from the team"]
             [:li "Post on the same Instagram accounts"]
             [:li "See and modify the shared gallery"]
             [:li "See post history and upcoming posts"]]]]]]

        [:div
         {:class ["px-6" "py-5"]}
         [:label
          {:class ["block" "text-sm" "font-medium" "text-gray-900" "mb-1"]}
          "Email address"]
         [:p
          {:class ["text-sm" "text-gray-500" "mb-3"]}
          "We will send an invitation email with signup instructions."]
         [:input
          {:type "email"
           :required true
           :placeholder "colleague@example.com"
           :value (or (::email state) "")
           :class ["block" "w-full" "rounded-lg" "border" "border-gray-300"
                   "px-3" "py-2.5" "text-sm" "text-gray-900" "shadow-sm"
                   "placeholder:text-gray-400"
                   "focus:ring-2" "focus:ring-indigo-600" "focus:border-indigo-600"]
           :on {:input [[:store/assoc-in [::email] :event/target.value]]
                :keyup [[:js/on-enter]
                        cmd-action]}}]

         (when (command/error? state cmd)
           [:div
            {:class ["mt-3" "rounded-lg" "bg-red-50" "border" "border-red-200"
                     "px-3" "py-2"]}
            [:p {:class ["text-sm" "text-red-700"]}
             (command/get-latest-error state cmd)]])

         [:div
          {:class ["mt-5" "flex" "items-center" "gap-3"]}
          [:button
           {:class (into ["inline-flex" "items-center" "px-4" "py-2.5" "text-sm"
                          "font-medium" "rounded-lg" "cursor-pointer"
                          "transition-colors"]
                         (if has-email?
                           ["text-white" "bg-indigo-600" "hover:bg-indigo-700"]
                           ["text-gray-400" "bg-gray-100" "cursor-not-allowed"]))
            :disabled (or (not has-email?)
                          (command/issued? state cmd))
            :on {:click (when has-email? [cmd-action])}}
           (if (command/issued? state cmd)
             "Sending..."
             "Send invitation")]
          [:ui/a.link
           {:ui/location
            {:location/page-id :pages/team
             :location/params {}}
            :class ["text-sm" "font-medium" "text-gray-600" "hover:text-gray-800"]}
           "Cancel"]]]]

       ])))

(def page
  {:page-id :pages/team-add-user
   :route [["ui" "team" "add-user"]]
   :on-load (fn [_location]
              [[:ui/hide-sidebar-on-mobile]])
   :render #'render})
